import React from "react";
import { Switch } from "../../ui/switch";
import { Label } from "../../ui/label";
import InputField from "./InputField";
import { HiInformationCircle } from "react-icons/hi";
import { cn } from "../../../lib/utils";

interface CheckboxInputFieldProps {
  item: any;
  index: number;
  onChange: (index: number, value: any) => void;
  hint?: string;
  warning?: boolean;
  warningMessege?: string;
  disabled?: boolean;
}

const CheckboxInputField: React.FC<CheckboxInputFieldProps> = ({
  item,
  index,
  onChange,
  hint,
  warning,
  warningMessege,
  disabled,
}) => {
  const isEnabled = item.checked_state ?? false;

  const handleToggle = (checked: boolean) => {
    onChange(index, {
      checked_state: checked,
      value: checked
        ? item.value || item.default_value || item.min_value || 0.5
        : null,
    });
  };

  return (
    <div className="col-span-2 flex flex-col bg-background border border-white/20 rounded-xl overflow-hidden">
      {/* Top Section: Toggle */}

      {/* Middle & Bottom Sections: Only when enabled */}
      {
        <>
          {/* Middle Section: Input */}
          <div
            className={cn(
              "grid grid-cols-2 gap-3 pl-3 py-1 pr-1 border-t border-white/5 bg-background transition-opacity duration-200 ",
            )}
          >
            <div className="flex items-center justify-between w-full">
              <Label className="uppercase text-[10px] font-bold tracking-wider text-muted-foreground flex items-center gap-1">
                {item.name}
              </Label>
              <Switch
                checked={isEnabled}
                disabled={disabled}
                onCheckedChange={handleToggle}
                className="h-4 w-8 data-[state=checked]:bg-emerald-500"
              />
            </div>
            <div className="flex flex-col gap-1">
              <InputField
                item={item}
                index={index}
                onChange={onChange}
                warning={warning}
                warningMessege={warningMessege}
                disabled={disabled}
              />
            </div>
          </div>

          {/* Bottom Section: Info Box */}
          {isEnabled && (
            <div className="px-3 pb-3 pt-1 bg-white/[0.02]">
              <div className="flex items-start gap-2 p-2 rounded-md bg-emerald-500/5 border border-emerald-500/10">
                <HiInformationCircle
                  className="text-emerald-500 mt-0.5 shrink-0"
                  size={14}
                />
                <div className="flex flex-col">
                  <p className="text-[9px] leading-tight text-muted-foreground font-medium">
                    {hint || item.hint_text}
                  </p>
                </div>
              </div>
            </div>
          )}
        </>
      }
    </div>
  );
};

export default CheckboxInputField;
